import { Button, Input, Card, Skeleton, Tooltip, Popover, Radio } from 'antd';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { APPID, APPLICATION_ID, authFeatureConstants, DEFAULT_GUID, FETCH_FILE_BYTES, REQUEST_PAYLOAD, TOOLTIP_TEXT } from '../../../shared/constants/commonConstants';
import { PROFILE_SAVECONTACT } from '../../../shared/constants/urlEndPoints';
import { SaveContactDetailResponse } from '../../../shared/models/hospitalProfile.model';
import SendRequest from '../../../shared/services/sendRequest.service';
import { canActivate, success } from '../../../utils/utility';
import { error } from './../../../utils/utility';
import { fetchAdminSwitch, fetchEnableDisable, fetchHospitalProfile } from '../../../store/actions/hospitalAction';
import AddContactForm from '../shared/AddContactForm';
import './Contact.less';
import Panel from './../../../shared/components/card/Panel';
import DoctorImage from '../../../shared/components/doctImage/DoctorImage';
import _ from 'lodash';
import NoDataFound from '../../inventry/shared/NoDataFound';
import { MailOutlined, PhoneOutlined, SearchOutlined } from '@ant-design/icons';
import { RootState } from '../../../store';
import { HospitalState } from '../../../store/models/hospitalModel';
import { RadioChangeEvent } from 'antd/lib/radio';
const { Meta } = Card;

const Contact = (): any => {
  const [profileDetail, setProfileDetailHandler] = useState(null as any);
  const [contactData, setContactData] = useState(null as any);
  const [value, setValue] = useState(1);
  const {adminSwitchAction, enableDisableClick} = useSelector((state: RootState): HospitalState => state.hospital);
  const [isShowEditContact, setIsShowEditContact] = useState(false);
  const [contactEditData, setContactEditData] = useState(null as any);
  const [isVisible, setIsVisible] = useState(false);
  const dispatch = useDispatch();
  const [name, setName] = useState('');
  const [filterSelected, setFilterSelected] = useState('All');

  const [foundUsers, setFoundUsers] = useState(contactData);
  const maxLength = 10;

  const filter = (e: any): any => {
    const keyword = e.target.value;
    setName(keyword);
  };

  useEffect((): void => {
    const results = contactData?.filter((user: any): any => {
      return user?.name?.toLowerCase().startsWith(name.toLowerCase()) || user?.email?.toLowerCase().startsWith(name.toLowerCase());
    });
    let finalResults = [];
    if (filterSelected === 'Enabled') {
      finalResults = results.filter((user: any): any => {
        return user?.isEnabled;
      });
    } else if (filterSelected === 'Disabled') {
      finalResults = results.filter((user: any): any => {
        return !user?.isEnabled;
      });
    } else {
      finalResults = results;
    }
    setFoundUsers(finalResults);
  }, [filterSelected, name]);

  useEffect((): void => {
    if (contactData?.length) {
      setFoundUsers(contactData);
    }
  }, [contactData]);

  const apiHospitalProfile = useSelector(
    ({ hospital: { hospitalProfile } }: any): any => hospitalProfile,
  );
  const isNewEntry = useSelector(
    ({ hospital: { newEntry } }: any): any => newEntry,
  );
  useEffect((): void => {
    if (
      apiHospitalProfile &&
      apiHospitalProfile.length > 0 &&
      apiHospitalProfile[0]
    ) {
      const [data]: any = apiHospitalProfile || [];
      setProfileDetailHandler(data);
    }
  }, [apiHospitalProfile]);

  useEffect((): void => {
    if (profileDetail) {
      const cData = profileDetail?.contactDetails;
      const fileIds = [] as any;
      const newData = [] as any;
      if (cData && cData.length > 0) {
        setContactData(_.sortBy(cData, 'contactId'));
        // eslint-disable-next-line
        cData.map((x: any): any => {
          if (x.fileId && x.fileId !== DEFAULT_GUID) {
            fileIds.push(x.fileId);
          } else {
            newData.push({ ...x, fileByte: '' });
          }
        });
        if (fileIds && fileIds.length > 0) {
          getFileBytes(fileIds).then((resp: any): void => {
            if (resp && resp.isSuccess && resp.fileDetails && resp.fileDetails.length > 0) {
              // eslint-disable-next-line
              cData.map((item: any): any => {
                // tslint:disable-next-line: typedef
                const q = resp.fileDetails.find((y: any) => y.fileGuid === item.fileId);
                if (q && q.fileBytes) {
                  newData.push({ ...item, fileByte: q.fileBytes });
                }
              });
              if (newData && newData.length > 0) {
                setContactData(_.sortBy(newData, 'contactId'));
              }
            }
          });
        }
      } else {
        setContactData(null);
      }
    }
    dispatch(fetchAdminSwitch(false));
  }, [profileDetail]);

  const onCancel = (): void => {
    onEditContact();
    dispatch(fetchAdminSwitch(false));
  };

  const onEditContact = (data?: any): any => {
    setIsShowEditContact(!isShowEditContact);
    if (data && data.contactId) {
      setContactEditData(data);
      if (data && data.contactId && data?.isAdmin) {
        dispatch(fetchAdminSwitch(true));
      } else if (data && data.contactId && !data?.isAdmin) {
        dispatch(fetchAdminSwitch(false));
      }
      if (data && data.contactId && data?.isEnabled) {
        dispatch(fetchEnableDisable(true));
      } else if (data && data.contactId && !data?.isEnabled) {
        dispatch(fetchEnableDisable(false));
      }
    } else {
      setContactEditData({});
    }
  };
  const adminContact = async ({ data }: any): Promise<any> => {
    if (data) {
      const saveUrl = `${process.env.REACT_APP_BASE_URL}${PROFILE_SAVECONTACT}`;
      const payload: any = {
        applicationId: APPLICATION_ID,
        contactDetails: [
          {
            profileId: data?.profileId,
            name: data?.name,
            email: data?.email,
            landlineNumber: data?.landlineNumber,
            number: data?.number,
            isActive: true,
            isAdmin: !adminSwitchAction?.data ? !adminSwitchAction?.data : !adminSwitchAction,
            contactId: data?.contactId,
            contactUserId: data?.contactUserId,
            imageReferenceId: data?.imageReferenceId,
            fileName: data?.fileName,
            fileId: data?.fileGuid,
            department: data?.department,
            functions: data?.functions,
            designation: data?.designation,
          },
        ],
      };
      const res: SaveContactDetailResponse = await SendRequest.instance.post<any, any>(saveUrl, payload);
      if (res && res.isSuccess) {
        dispatch(fetchHospitalProfile(REQUEST_PAYLOAD));
        success(`Updated Successfully`);
        onEditContact();
      } else {
        error(res?.errorMessage);
      }
    }
  };
  const enableDisableContact = async ({ data }: any): Promise<any> => {
    if (data) {
      const saveUrl = `${process.env.REACT_APP_BASE_URL}${PROFILE_SAVECONTACT}`;
      const payload: any = {
        applicationId: APPLICATION_ID,
        contactDetails: [
          {
            profileId: data?.profileId,
            name: data?.name,
            email: data?.email,
            landlineNumber: data?.landlineNumber,
            number: data?.number,
            isActive: true,
            isAdmin: data?.isAdmin,
            isEnabled: !enableDisableClick?.data ? !enableDisableClick?.data : !enableDisableClick,
            contactId: data?.contactId,
            contactUserId: data?.contactUserId,
            imageReferenceId: data?.imageReferenceId,
            fileName: data?.fileName,
            fileId: data?.fileId,
            department: data?.department,
            functions: data?.functions,
            designation: data?.designation,
          },
        ],
      };
      const res: SaveContactDetailResponse = await SendRequest.instance.post<any, any>(saveUrl, payload);
      if (res && res.isSuccess) {
        dispatch(fetchHospitalProfile(REQUEST_PAYLOAD));
        success('Updated Successfully');
        onEditContact();
      } else {
        error(res?.errorMessage);
      }
    }
  };
  const onAdminContact = (data: any): any => {
    if (data?.contactId && data?.contactUserId) {
      adminContact({ data });
    }
  };
  const onEnableDisableContact = (data: any): any => {
    if (data?.contactId && data?.contactUserId) {
      enableDisableContact({ data });
    }
  };

  const getFileBytes = async (docIds: string[]): Promise<any> => {
    const request = {
      applicationId: APPID,
      fileIdentifiers: docIds,
    };
    const result = await SendRequest.instance.post(process.env.REACT_APP_BASE_URL + FETCH_FILE_BYTES, request);
    return result;
  };
  const onChange = (e: RadioChangeEvent): any => {
    setValue(e.target.value);
    setFilterSelected(e.target.value === 1 ? 'All' : e.target.value === 2 ? 'Enabled' : 'Disabled');
  };
  const content = (
    <div>
      <Radio.Group className="column-direction" onChange={onChange} value={value}>
        <Radio value={1}>All</Radio>
        <Radio value={2}>Enabled</Radio>
        <Radio value={3}>Disabled</Radio>
      </Radio.Group>
    </div>
  );
  return (
    <>
      <Panel
        className="contact-width"
        title="User Accounts"
        extra={<Popover
          onVisibleChange={(ev: any): void => setIsVisible(ev)}
          visible={isVisible}
          content={content}
          trigger="click"
          placement="bottomLeft">
          <Button data-testid="table-configurator" type="link"
            onClick={(): any => setIsVisible(!isVisible)}>Filter <span style={{
              color: 'black',
              marginLeft: '2px',
            }}>({filterSelected})</span></Button>
        </Popover>}>
        {(!isNewEntry && canActivate(authFeatureConstants.EDIT_USER)) &&
          <div className="contacts contact-create-header">
            <Tooltip title={TOOLTIP_TEXT.add}>
              <Button onClick={onEditContact} className="mouse-pointer fill-primary contact-edit contact-create"
                type="link">Create New Account</Button></Tooltip>

            <Input
              onChange={filter}
              value={name}
              className="input-search"
              placeholder="Search for name or email"
              suffix={<SearchOutlined />}
            />
          </div>
        }
        {
          ((!isNewEntry && (contactData && !contactData.length))) ?
            <>
              <Skeleton active={true} paragraph={{ rows: 2 }} />
              <Skeleton active={true} paragraph={{ rows: 2 }} />
            </> :
            (isNewEntry || !contactData) && <NoDataFound />
        }
        {
          foundUsers && foundUsers?.length > 0 &&
          // tslint:disable-next-line: typedef
          foundUsers?.map((x: any, i: number) => {
            return <div key={x.isActive + 'i' + i} className="contacts" >
              <Card
                className= {x?.isEnabled ? 'contact-dimension-enabled' : 'contact-dimension contact-dimension-disabled ant-card-actions' }
                actions={[
                  <div className="contact-actions" key="edit">
                    <Tooltip title={canActivate(authFeatureConstants.EDIT_USER) ? 'Edit' : 'View'} key="edit">
                      {canActivate(authFeatureConstants.EDIT_USER) ?
                        <Button className="contact-edit" key="edit"
                          type="link" onClick={(): any =>
                            onEditContact(x)}>Edit<span className="contact-enable-switch">
                              {x?.isEnabled ? 'Enabled' : 'Disabled'}</span></Button> :
                        <span className="contact-enable-switch">{x?.isEnabled ? 'Enabled' : 'Disabled'}</span>}
                    </Tooltip></div>,
                ]}
              >
                <Meta
                  avatar={
                    (x.fileByte && x.fileId && x.fileId !== DEFAULT_GUID)
                      || (!x.fileId || (x.fileId && x.fileId === DEFAULT_GUID))
                      ? <DoctorImage imgUrl={x.fileByte} status= "none"/> :
                      <Skeleton.Avatar
                        style={{ marginRight: '10px', height: '45px', width: '45px' }} active={true} size={'large'} />
                  }
                  title={<p className="m-0 bold text-elipsis" ><Tooltip title={x.name}>
                    {x.name.length > maxLength ? `${x.name.slice(0, maxLength)}...` : x.name}
                    <span className="admin-font">{x.isAdmin && 'Admin'}</span>
                  </Tooltip></p>}
                  description={<div className="contact-details-dimension">
                    {x.landlineNumber &&
                       <><PhoneOutlined className="fill-gray" /><span className="fsize_sm"> {x.landlineNumber}</span></>
                    }
                    {x.number &&
                      <p className="m-0"> <PhoneOutlined className="fill-gray" /> <span className="fsize_sm"> {x.number}</span> </p>
                    }
                    <p className="m-0 text-elipsis">
                      <MailOutlined className="fill-gray v-align-middle" />
                      <Tooltip title={x.email}> <span className="fsize_sm">{x.email}</span> </Tooltip>
                    </p>
                  </div>}
                />
              </Card>{// tslint:disable-next-line: semicolon
              }</div>
          })
        }
      </Panel>
      {
        isShowEditContact &&
        <AddContactForm
          visible={isShowEditContact}
          onCancel={onCancel}
          onEnableDisableContact ={onEnableDisableContact}
          onAdminContact = {onAdminContact}
          profileId={profileDetail?.id}
          contact={contactEditData}
          onEditContact={onEditContact}
          imgUrl={contactEditData?.fileByte}
          title={'User Account Details'}
        />
      }
    </>);
};
export default Contact;
